import { BaseRequestOptions, BaseResponseOptions, RequestInterceptor } from './types';

/**
 * Applies the requestOptions() method of `interceptor` to the passed options. Since the
 * interceptor is possibly undefined but callers expect a value, handles that case.
 *
 * @param interceptor A RequestInterceptor that could not be defined.
 * @param requestOptions The options to pass to requestOptions().
 * @param url The url to pass to requestOptions().
 */
export function requestInterceptorOptions<
  Req extends BaseRequestOptions,
  Res extends BaseResponseOptions,
>(
  interceptor: RequestInterceptor<Req, Res> | null | undefined,
  requestOptions: Req,
  url: string,
) {
  if (!interceptor || !interceptor.requestOptions) {
    return requestOptions;
  }
  return interceptor.requestOptions(requestOptions, url);
}

/**
 * Applies the response() method of `interceptor` to the passed options. Since the
 * interceptor is possibly undefined but callers expect a value, handles that case.
 *
 * @param interceptor A RequestInterceptor that could not be defined.
 * @param response The response to pass to response().
 */
export function requestInterceptorResponse<
  Req extends BaseRequestOptions,
  Res extends BaseResponseOptions,
>(interceptor: RequestInterceptor<Req, Res> | null | undefined, response: Res) {
  if (!interceptor || !interceptor.response) {
    return response;
  }
  return interceptor.response(response);
}
